import { useMemo } from 'react'
import { shallowEqual } from 'react-redux'

interface IProps {
  previousState: any
  nextState: any
  isFormValid: boolean
}

export const useSaveFormStatus = ({ previousState, nextState, isFormValid }: IProps) => {
  const isFormChanged = useMemo(
    () => !shallowEqual(previousState, nextState),
    [previousState, nextState]
  )
  const isSaveEnabled = isFormChanged && isFormValid
  const disableSaveMessage = useMemo(() => {
    let message = ''
    if (!isFormValid) {
      message = 'Please, fill the form correctly'
    } else if (!isFormChanged) {
      message = 'No changes to save'
    }

    return message
  }, [isFormChanged, isFormValid])

  return { isSaveEnabled, disableSaveMessage }
}
